import { ProfileTypes } from './actionTypes';

export const viewProfile = (user: any) => {
  return {
    type: ProfileTypes.VIEW_PROFILE,
    payload: { user },
  };
};

export const editProfile = (user: any) => {
  return {
    type: ProfileTypes.EDIT_PROFILE,
    payload: { user },
  };
};

export const profileSuccess = (msg: any) => {
  return {
    type: ProfileTypes.PROFILE_SUCCESS,
    payload: msg,
  };
};

export const profileError = (error: any) => {
  return {
    type: ProfileTypes.PROFILE_ERROR,
    payload: error,
  };
};

export const resetProfileFlag = () => {
  return {
    type: ProfileTypes.RESET_PROFILE_FLAG,
  };
};

export const updatePhotoProfile = (photo: any) => {
  return {
    type: ProfileTypes.UPDATE_PROFILE_PICTURE,
    payload: photo,
  };
};

export const updatePhotoProfileSuccess = (url: any) => {
  return {
    type: ProfileTypes.UPDATE_PROFILE_PICTURE_SUCCESS,
    payload: url,
  };
};
